/* eslint-disable no-debugger */
import useUserGroupAddForm from "./UseUserGroupAddForm";

import UserGroupMultiSelect from "../multiselect/UserGroupMultiSelect";

import PrimaryButton from "@usas/ui-web/components/buttons/PrimaryButton";
import SecondaryButton from "@usas/ui-web/components/buttons/SecondaryButton";
import ApprovedClubCombobox from "@usas/ui-web/components/comboboxes/approvedClubCombobox/ApprovedClubCombobox";
import YesNoSwitch from "@usas/ui-web/components/yesNoSwitch/YesNoSwitch";

const UserGroupAddForm = ({
  submitButtonText = 'Save',
  SecondaryButtonText = 'Back',
  onSubmitFormCallback,
  onSecondaryButtonClicked,
  memberId }) => {

  const {
    formState,
    errorState,
    handleSubmit,
    updateFormState,
    onValueTextPairChanged,
    onFormValueChanged,
    isNewClubApplication
  } = useUserGroupAddForm(onSubmitFormCallback, memberId);

  return (
    <form onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-xs-12 col-sm-6 col-md-4">
          <UserGroupMultiSelect
            label={'User Group*'}
            name={'userGroup'}
            value={formState.userGroup}
            error={errorState.userGroup}
            message={errorState.userGroup}
            onChange={(value) => { updateFormState('userGroup', value); }} />
        </div>
      </div>
      {isNewClubApplication && (
        <div className="row">
          <div className="col-xs-12 col-sm-6 col-md-4">
            <ApprovedClubCombobox
              label="Club Reuse"
              name="orgUnitName"
              valueToMatch={formState.orgUnitName}
              error={errorState.orgUnitId}
              message={errorState.orgUnitId}
              onChange={(newValue, newValueLabel, e) => { onValueTextPairChanged(newValue, 'orgUnitId', newValueLabel, 'orgUnitName', e); }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <YesNoSwitch
              label="Use Renewal Fee*"
              name="useRenewalFee"
              checked={formState.useRenewalFee}
              error={errorState.useRenewalFee}
              message={errorState.useRenewalFee}
              onChange={(value) => { onFormValueChanged('useRenewalFee', value) }} />
          </div>
        </div>
      )}

      <div className="row">
        <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
          <PrimaryButton type="submit">{submitButtonText}</PrimaryButton>&nbsp;
          <SecondaryButton type="button" onClick={onSecondaryButtonClicked}>{SecondaryButtonText}</SecondaryButton>
        </div>
      </div>
    </form>
  );
};

export default UserGroupAddForm;